import { render, staticRenderFns } from "./PostQuestionnaire.vue?vue&type=template&id=38856178&scoped=true"
import script from "./PostQuestionnaire.vue?vue&type=script&lang=js"
export * from "./PostQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./PostQuestionnaire.vue?vue&type=style&index=0&id=38856178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38856178",
  null
  
)

export default component.exports